/** Planets shown in the top bar transit snippet (transit snapshot; Sun omitted). */
const ELIGIBLE = new Set(["moon", "mercury", "venus", "mars", "jupiter", "saturn", "uranus", "neptune", "pluto"]);

/** Among retrogrades, prefer bodies users most often notice. */
const RETROGRADE_PRIORITY = ["mercury", "venus", "mars", "jupiter", "saturn", "uranus", "neptune", "pluto", "moon"];

function retrogradeRank(planet) {
  const i = RETROGRADE_PRIORITY.indexOf(planet);
  return i === -1 ? 999 : i;
}

function humanizePlanet(planet) {
  const p = String(planet || "");
  if (!p) return "";
  return p.charAt(0).toUpperCase() + p.slice(1);
}

/**
 * Option A: any retrograde planet first (by salience order), else fastest apparent motion.
 * @param {Array<{ planet?: string, retrograde?: boolean, speed?: number }>} positions
 * @returns {{ planet: string, retrograde: boolean, speedAbs: number } | null}
 */
export function pickSalientTransitPlanet(positions) {
  if (!Array.isArray(positions) || positions.length === 0) return null;

  const rows = positions
    .map((p) => {
      const planet = String(p?.planet || "").toLowerCase().trim();
      if (!ELIGIBLE.has(planet)) return null;
      const retrograde = Boolean(p?.retrograde);
      const speed = Number(p?.speed);
      const speedAbs = Number.isFinite(speed) ? Math.abs(speed) : 0;
      return { planet, retrograde, speedAbs };
    })
    .filter(Boolean);

  if (rows.length === 0) return null;

  const retrogradeRows = rows.filter((r) => r.retrograde);
  if (retrogradeRows.length > 0) {
    retrogradeRows.sort((a, b) => retrogradeRank(a.planet) - retrogradeRank(b.planet));
    return retrogradeRows[0];
  }

  rows.sort((a, b) => b.speedAbs - a.speedAbs);
  return rows[0];
}

/**
 * @param {{ planet: string, retrograde: boolean } | null} salient
 * @param {(key: string, defaultValue?: string) => string} t
 */
export function formatTopbarTransitHighlight(salient, t) {
  if (!salient) return t("topbar_transit_unavailable");

  const name = t(`wz_planet_${salient.planet}`, humanizePlanet(salient.planet));
  const motion = salient.retrograde ? t("topbar_motion_retrograde") : t("topbar_motion_direct");
  return t("topbar_transit_highlight").replace("%{planet}", name).replace("%{motion}", motion);
}
